var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.372,
    height: 53.102,
    viewBox: "0 0 59.372 53.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_1_",
    "data-name": "warning (1)",
    transform: "translate(0 -27.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    "data-name": "Path 4063",
    d: "M24.188,30.208.86,70.613a6.349,6.349,0,0,0,5.5,9.523H53.014a6.349,6.349,0,0,0,5.5-9.523L35.184,30.208a6.349,6.349,0,0,0-11,0Z",
    transform: "translate(0)",
    fill: "#da4a54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4064",
    "data-name": "Path 4064",
    d: "M42.792,111.786a1.57,1.57,0,0,1-1.36-2.356l23.328-40.4a1.57,1.57,0,0,1,2.72,0l23.328,40.4a1.57,1.57,0,0,1-1.36,2.355H42.792Z",
    transform: "translate(-36.433 -36.428)",
    fill: "#f6e266"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(26.667 41.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4065",
    "data-name": "Path 4065",
    d: "M232.983,175.713a3.019,3.019,0,0,1-3.019-3.019V158.869a3.019,3.019,0,0,1,6.038,0v13.825A3.019,3.019,0,0,1,232.983,175.713Z",
    transform: "translate(-229.964 -155.85)",
    fill: "#544f57"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3.019,
    cy: 3.019,
    r: 3.019,
    transform: "translate(0 23.107)",
    fill: "#544f57"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f0a557da127124169eab1aa5a722c57b.svg";
export { ForwardRef as ReactComponent };